import React, { useCallback, useState, useEffect } from 'react'
import { useMergeLink } from '@mergeapi/react-merge-link'
import {
  getAccessToken,
  integrateMerge,
} from '../../reducers/integrations/resources'

const App = (props) => {
  const [token, setToken] = useState('')

  async function getToken() {
    const token = await getAccessToken(`type=merge`)
    setToken(token.data)
  }

  useEffect(() => {
    if (!props.connected) {
      getToken()
    }
  }, [])

  if (!props.connected) {
    const onSuccess = useCallback(async (public_token) => {
      // Send public_token to server (Step 3)
      await integrateMerge({ publicToken: public_token })
      props.successCallback()
    }, [])

    const { open, isReady } = useMergeLink({
      linkToken: token,
      onSuccess,
    })

    return (
      <a disabled={!isReady} style={{ cursor: 'pointer' }} onClick={open}>
        {props.card}
      </a>
    )
  }

  return <a onClick={props.unlink}>{props.card}</a>
}

export default App
